import React from "react";
import Badge from "@mui/material/Badge";

export default function ItemCountBadge({ count }) {
  return (
    <Badge
      badgeContent={count}
      max={999999}
      sx={{
        '& .MuiBadge-badge': {
          position: 'relative',
          transform: 'none',
          backgroundColor: 'transparent',
          color: '#666',
          fontSize: '14px',
          height: '24px',
          minWidth: '24px',
          borderRadius: '50%',
          fontWeight: 500,
          border: '1.5px solid #999',
        }
      }}
    />
  );
}
